import { ITrade } from './trade'
import { ETradeChannel, EPaymentBrand } from './enum'
import { IQueryParams, IPagination } from './common'

/** ææ£éæ¾ */
export interface ITradeHoldReq {
  intStoreCode: string,
  origOrderNum: string
  reason: string,
  remark: string,
}

export interface ITradeReleaseReq {
  reason: string,
  remark: string,
}

export interface ITradeHoldCheckReq {
  intStoreCode: string
  origOrderNum: string
  remark?: string
}

export interface IHoldReleaseDetailObj {
  trans: ITrade,
  riskStatus: ERiskStatus
  holdDetail: IHoldReleaseDetail,
  releaseDetail: IHoldReleaseDetail,
}

export interface ICodeMsgResponse {
  code: string,
  msg: string,
}

export enum ERiskStatus {
  'Holded' = 'holded',
  'Released' = 'released',
}

export enum ERiskStatusMap {
  'holded' = 'OPERATION.HOLD',
  'released' = 'OPERATION.RELEASE',
}

export enum EHoldErrorCode {
  Holded = 'MSG_CODE.BIZ.TRANS_HOLDED',
}

export interface IHoldReleaseDetail {
  riskTime: string,
  reason: string,
  operator: string,
  remark: string,
}

export enum EHoldReason {
  '01' = 'OPERATION.HOLD.REASON.RISKTRADE',
  '02' = 'OPERATION.HOLD.REASON.FAKECARD',
}

export enum EReleaseReason {
  '03' = 'OPERATION.RELEASE.REASON.NORISK',
  '04' = 'OPERATION.RELEASE.REASON.HOLDTOOLONG'
}

/** å·®é */
export interface IChargeBack {
  /** æ¡ä¾ç¼å· */
  disputeNum: string
  storeName: string
  storeNameEN: string

  /** ARN */
  acqReferData: string

  /** å¡åç */
  cardBrand: ETradeChannel

  /** å·®éæ¶é´ */
  transDateTime: string

  /** å·®éç±»å */
  transCode: EChargeBackTransCode

  /** æ¸ é */
  channel: EPaymentBrand,

  /** å·®ééé¢ */
  transAmt: number

  /** æ£æ¬¾éé¢ */
  billingAmt: number

  /** å¸ç§ */
  transCurr: string

  /** æ£æ¬¾å¸ç§ */
  billingCurr: string

  /** ç¶æ */
  processFlag: string /** ProcessTypeMap */

  /** å¤çæ¹å¼  */
  processType: EChargeBackProcessType

  /** æ£ç´¢åèå· */
  refNum: string

  /** å¡å· */
  cardNum: string

  /** ææç  */
  authCode: string

  /** ARN */
  ARN: string

  /** åå ä»£ç  åç«¯è¿åå°±æ¯ resonCode */
  resonCode: string

  /** æä½ç¨æ· */
  operator: string

  /** å¤æ³¨ */
  remark: string

  /** åäº¤æ */
  origTrans?: ITrade

  /** æ£æ¬¾éé¢ */
  upTransAmt: number

  /** æ£æ¬¾éé¢å¸ç§ */
  upTransCurr: string

  /** åè¯·æ¬¾éé¢ */
  downTransAmt: number

  /** åè¯·æ¬¾éé¢å¸ç§ */
  downTransCurr: string

  /** åè¯·æ¬¾éé¢ */

  /** å·®éæ¥æ */
  createdAt: string,
  updatedAt: string,
}

export enum EChargeBackTransCode {
  /** è°å Retrival */
  RTV = 'RTV',
  /** éå Chargeback */
  FCB = 'FCB',
  /** äºæ¬¡éå Second-Chargeback */
  SCB = 'SCB',
  /** éå Reject */
  REJ = 'REJ',
}

export enum EChargeBackStatus {
  /** å¾å¤ç */
  Todo = '0',

  /** å·²å®æ */
  Done = '1',

  /** å·²å³é­ */
  Closed = '2',
}

/** å¤çæ¹å¼ */
export enum EChargeBackProcessType {
  /** æªå¤ç, åç«¯ä¸å±ç¤º */
  // NotHandled = '0',

  /** åæ·æ£æ¬¾ */
  MerchantDebit = '1',

  /** åè¯·æ¬¾ */
  Representment = '2',

  /** è°ååå¤ */
  Retrievaled = '3',

  /** è°ååå¤, åå·²è°å  */
  // RetrievalRespond = 'RetrievalRespond',

  /** ä»²è£ */
  Arbitrate = '4',

  /** æ£æ¬¾åè¯·æ¬¾ */
  DebitAndRepresent = '5',

  /** å³é­ */
  Close = '9',
}

export const ChargeBackStatusMap = {
  0: 'OPERATION.CHARGEBACK.PROCESSFLAG.NOTHANDLED',
  1: 'OPERATION.CHARGEBACK.PROCESSFLAG.DONE',
  2: 'OPERATION.CHARGEBACK.PROCESSFLAG.CLOSED',
}

export const ChargeBackProcessTypeMap = {
  // 0: 'OPERATION.CHARGEBACK.PROCESSTYPE.NOTHANDLED',
  1: 'OPERATION.CHARGEBACK.PROCESSTYPE.MERCHANTDEBIT',
  2: 'OPERATION.CHARGEBACK.PROCESSTYPE.REPRESENTMENT',
  3: 'OPERATION.CHARGEBACK.PROCESSTYPE.RETRIEVALED',
  4: 'OPERATION.CHARGEBACK.PROCESSTYPE.ARBITRATE',
  5: 'OPERATION.CHARGEBACK.PROCESSTYPE.DEBITANDREPRESENT',
  9: 'OPERATION.CHARGEBACK.PROCESSTYPE.CLOSE',
}

export const ChargeBackTransCodeMap = {
  /** è°å */
  RTV: 'OPERATION.CHARGEBACK.TRANSCODE.RETRIVAL',
  /** éå */
  FCB: 'OPERATION.CHARGEBACK.TRANSCODE.CHARGEBACK',
  /** äºæ¬¡éå */
  SCB: 'OPERATION.CHARGEBACK.TRANSCODE.SECOND-CHARGEBACK',
  /** éå */
  REJ: 'OPERATION.CHARGEBACK.TRANSCODE.REJECT',
}

export const ProcessFlagMap = {
  0: 'æªå¤ç',
  1: 'å·²å®æ',
  2: 'å·²å³é­',
}

export const ReasonCodeMap = {
  2000:	'General â invalid Chargeback',
  2001:	'Invalid Acquirer reference number on Chargeback',
  2002:	'Non-receipt of required documentation to support Chargeback',
  2003:	'Correct transaction date provided',
  2004:	'Correct merchant description provided (DBA)',
  2005:	'Correct merchant location provided',
  2006:	'Incorrect transaction date provided on Chargeback',
  2007:	'Transaction did not exceed Network (Card Acceptor) floor limit',
  2008:	'Transaction authorized by Issuer',
  2009:	'No error in addition of sale â amount correct in original transaction',
  2010:	'No proof of altered amount (customer stated in Chargeback that amount had been altered)',
  2011:	'Credit previously issued',
  2012:	'Original transaction was valid',
  2700:	'Per local regulation proof of government id validation can not be provided',
  2701:	'Valid ATM Journal Roll/Audit Tape Provided',
  4516:	'Non-fulfillment of request for information (Request for Support Not Fulfilled)',
}

/** æ¥è¯¢åè¡¨è¯·æ±ä½ */
export interface IChargeBackQueryParams extends IQueryParams {
  startTime?: string
  endTime?: string
  orderNum?: string
  chargeAmtFrom?: number
  chargeAmtTo?: number
  currency?: string
  channel?: string
  refNum?: string
  codeNum?: string
  authCode?: string
  ARN?: string
  reasonCode?: string
  type?: string
  handleMethod?: string
  status?: string
  insCode?: string
  agentCode?: string
  intMerCode?: string
  intStoreCode?: string
}

/** æ¥è¯¢åè¡¨è¿åæ°æ® */
export interface IChargeBackPagination extends IPagination {
  data: IChargeBack[]
}

/** å¤çè¯·æ±ä½ */
export interface IChargeBackOperateReq {
  /** ç¼å· */
  disputeNum: string
  /** å¤çæ¹å¼ */
  processType: EChargeBackProcessType
  /** æä½å¤æ³¨ */
  remark: string
  /** éé¢ */
  transAmt?: number
  /** åå ä»£ç  */
  reasonCode?: string
  /** MMT */
  memMessTxt?: string
  /** ææ¬æ å¿ */
  docIndicator?: boolean
}

/** è¯·æ±ç»æä½ç±» */
export class OperateBody {
  remark: string
  amt: number
  reasonCode: string
  MMT: string
  docIndicator = true
}

export enum EChargeOperateBodyI18n {
  remark = 'OPERATION.CHARGEBACK.OPERATEREMARK',
  amt = 'TRADE.CHARGEBACK.AMT',
  reasonCode = 'OPERATION.CHARGEBACK.REASONCODE',
  MMT = 'OPERATION.CHARGEBACK.MMT',
  docIndicator = 'OPERATION.CHARGEBACK.DOCINDICATOR'
}

